import styled, { css } from 'styled-components';
import theme from 'src/theme';

export const Wrapper = styled.div`
    font-size: 0.8rem;
    margin: 1px;
    flex: 0 0 50%;
    height: calc(100% - 50px);
    overflow-y: auto;
    max-height: 100%;
    h4 {
        color: #e65100;
        font-weight: 400;
        font-size: 0.9rem;
        padding: 2px;
        border-bottom: 1px solid #e651008a;
        margin: 5px 0;
    }
`;

export const HeadingWrapper = styled.div`
    display: flex;
    justify-content: left;
    font-size: 0.9rem;
    padding: 5px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
`;

export const ToolboxWrapperOptional = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
`;

export const ToolboxWrapperMandatory = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.8rem;
`;

export const EventInputWrapper = styled.div`
    height: 100%;
`;

export interface IButtonProps {
    isSelected?: boolean;
    onClick?: (eventTypeId: number) => void;
}

export const Icon = styled.i`
    color: ${theme.legacyColors.errorText};
`;

export const StyledButton = styled.button<IButtonProps>`
    background: #00aeef;
    border: 1px solid #00aeef;
    border-right: 0;
    color: #fff;
    font-size: 0.8rem;
    margin: 1px 0;
    outline: 0;
    cursor: pointer;
    border-radius: 0;
    position: relative;
    padding: 12px 8px 12px 40px;

    &.status-complete {
        border: 1px solid #4cb944;
        background: #4cb944;
    }

    &.status-exclude {
        border: 1px solid #ef5656;
        background: #ef5656;
    }

    &.status-in-progress {
        border: 1px solid #f1be39;
        background: #f1be39;
    }

    &.list-item {
        border: 0;
        text-align: left;
        color: #04265a;
        padding: 0.5rem 1rem 0.5rem 2rem;
        line-height: 1rem;
        background: #fff;
        box-shadow: 0 5px 5px -3px #ddd;
        border-bottom: 1px solid #ddd;
        ${({ isSelected }) =>
            isSelected &&
            css`
                background: #fff;
                border: 1px solid #04265a;
            `}
    }

    &.status-muted {
        border: 1px solid #aaa;
        background: #a34198;
    }

    .event-icon {
        position: absolute;
        left: 5px;
        top: 15%;
        width: 1.15rem;
        height: 18px;

        svg {
            fill: #04265a;
            width: 100%;
        }
    }

    .right-arrow-icon {
        position: absolute;
        right: 5px;
        top: 35%;
    }
`;
